module.exports = __webpack_public_path__ + "components/app-store/static/s1-a50a57d574481268a29dae91fd5f185a.jpg";